<form
  [formGroup]="searchBarForm"
  (ngSubmit)="onSubmit()">
  <mat-form-field
    class="search-bar"
    appearance="fill"
    [attr.openedMenu]="auto.isOpen">
    <button
      mat-icon-button
      matPrefix
      class="search-button"
      type="submit"
      matTooltip="Search"
      data-cy="searchbar-search-button">
      <mat-icon svgIcon="magnify"></mat-icon>
    </button>

    <input
      #searchInput
      matInput
      placeholder="Search folders and jobs"
      formControlName="searchBarField"
      [matAutocomplete]="auto"
      #trigger="matAutocompleteTrigger"
      data-cy="searchbar-input" />

    @if (searchInput.value) {
      <button
        mat-icon-button
        matSuffix
        class="clear-button"
        type="button"
        matTooltip="Clear"
        (click)="onClear()"
        data-cy="searchbar-clear-button">
        <mat-icon svgIcon="close"></mat-icon>
      </button>
    }
    <mat-autocomplete
      #auto="matAutocomplete"
      class="quickResultsPanel"
      data-cy="quick-results-panel">
      @if (searchResultsProdResource.isLoading() || searchResultsTestResource.isLoading()) {
        <mat-option>
          <uic-loading-dots></uic-loading-dots>
        </mat-option>
      } @else {
        @for (item of searchResultsCombined().prod.results; track item) {
          <mat-option
            class="search-options"
            (onSelectionChange)="onQuickResultSelected(item, 'PROD')"
            data-cy="quick-results-option">
            <mat-icon [svgIcon]="isFolder(item) ? 'folder-outline' : 'cog-outline'"></mat-icon>
            {{ item.name }}
            <p class="description">{{ item.description }}</p>
          </mat-option>
        }
        @for (item of searchResultsCombined().test.results; track item) {
          <mat-option
            class="search-options"
            (onSelectionChange)="onQuickResultSelected(item, 'TEST')"
            data-cy="quick-results-option">
            <mat-icon [svgIcon]="isFolder(item) ? 'folder-outline' : 'cog-outline'"></mat-icon>
            {{ item.name }}
            <p class="description">{{ item.description }}</p>
          </mat-option>
        }
      }
    </mat-autocomplete>
  </mat-form-field>
</form>
